import { IImageTypes } from 'components';
import { PricingModelInterface } from './boost';
import { ISiteConfiguration } from './site';

export interface IBoostGroupsResponse {
  totalElements: number;
  totalPages: number;
  sort: Sort;
  size: number;
  content: IBoostGroupModel[];
  number: number;
  numberOfElements: number;
  pageable: Pageable;
  first: boolean;
  last: boolean;
  empty: boolean;
}

export interface Sort {
  unsorted: boolean;
  sorted: boolean;
  empty: boolean;
}

export interface IBoostGroupModel {
  id?: number;
  name?: string;
  timezone?: string;
  language?: string;
  country?: string;
  currency?: string;
  ocpiCountryCode?: string;
  ocpiPartyId?: number;
  ownerId?: string;
  ownerName?: string;
  isSite?: boolean;
  theme?: string;
  groupHierarchy?: GroupHierarchy;
  groupConfiguration?: GroupConfiguration;
  siteConfiguration?: ISiteConfiguration;
  subBoostGroupId?: number;
  unassignedBoostCount?: number;
}

export interface SMSReceiptInterface {
  id?: number;
  merchant?: string;
  isEnabled?: boolean;
}

export interface GroupHierarchy {
  id?: number;
  parentId?: number;
  parentName?: string;
  depth?: number;
  subGroups?: any[];
  assetIds?: number[];
}

export interface GroupConfiguration {
  theme?: string;
  contact?: Contact;
  network?: string;
  pricing?: PricingModelInterface;
  pricingHistory?: PricingModelInterface[];
  rechargingThreshold?: number;
  hours?: Hour[];
  images?: IImageTypes[];
  smsReceipt?: SMSReceiptInterface;
  displayPackSOCOnScreen?: boolean;
}

export interface Contact {
  id?: number;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  region: string;
}

export interface PricingHistory {
  id: number;
  name: string;
  dischargingType: string;
  pricingType: string;
  isActive: boolean;
  tariffId: string;
  rate: number;
  preAuthAmount: number;
  minimumPayment: number;
  dischargingLowerLimit: number;
  dischargingHigherLimit: number;
  createdAt: string;
  updatedAt: string;
}

export interface Hour {
  type: string;
  day: string;
  timeRanges: TimeRange[];
  active: boolean;
}

export interface TimeRange {
  openTime: OpenTime;
  closeTime: CloseTime;
}

export interface OpenTime {
  hour: number;
  minute: number;
  second: number;
  nano: number;
}

export interface CloseTime {
  hour: number;
  minute: number;
  second: number;
  nano: number;
}

export interface Image {
  type: string;
  imageId: number;
  name?: string;
}

export interface Image {
  type: string;
  imageId: number;
}

export interface Pageable {
  sort: Sort;
  offset: number;
  paged: boolean;
  unpaged: boolean;
  pageNumber: number;
  pageSize: number;
}

export interface GroupConfigurationAddBoost {
  theme: string;
}

export interface GroupHierarchyAddBoost {
  assetIds: number[];
  parentId?: string;
}

export interface StandardListResponse {
  key?: string;
  value?: string;
}

export enum BoostGroupLookUpTypes {
  TIMEZONE = 'TIMEZONE',
  CURRENCY = 'CURRENCY',
  THEME = 'THEME',
  LANGUAGE = 'LANGUAGE',
  COUNTRY = 'COUNTRY',
  EV_NETWORK = 'EV_NETWORK',
  PRICING_TYPE = 'PRICING_TYPE',
  DISCHARGING_TYPE = 'DISCHARGING_TYPE',
  PAYMENT_TERMINAL_TYPE = 'PAYMENT_TERMINAL_TYPE'
}

export enum ImageTypes {
  CHARGING_SITE = 'CHARGING_SITE',
  GROUP_BACKGROUND = 'GROUP_BACKGROUND',
  GROUP_LOGO = 'GROUP_LOGO',
  GROUP_HELP_PAGE_CONTENT = 'GROUP_HELP_PAGE_CONTENT',
  GROUP_PRICE = 'GROUP_PRICE'
}

export enum BoostGroupOperation {
  SAVE = 'SAVE',
  DELETE = 'DELETE'
}
